import React, {Component} from 'react';
import {Select, Form, Icon, Modal, Pagination, Input, message} from "antd";
import {HEADER_HEIGHT} from "../../../../constants";
import BaseTable from "../../../components/baseTable/BaseTable";
import {Scrollbars} from "react-custom-scrollbars";
import BaseComponent from "../../../../base/BaseComponent";
import { uuid} from "../../../../utils";
import $ from  'jquery';

let {Search} = Input;
class SelectTagInput extends Component {

    static defaultProps = {
        width: 642,
        dataTableSelectProps:{},
    };

    className = "className"+uuid();
    componentDidMount() {
        $(".ant-select-search__field" ).attr("disabled","true");//再改成disabled
    }

    render() {
        let checkedData = [];
        let value = undefined;
        let {itemField, showField, dataTableSelect} = this.props;
        if(this.props.itemValue){
            checkedData = this.props.itemValue.map(item=>{
                return item[itemField];
            })
        }
        if(checkedData){
            value = checkedData.map(item=>{
                return item[showField];
            })
        }
        let marginRight = 20;
        return (
            <Form.Item label={this.props.label} required={this.props.empty} style={{display:"flex"}}>
                <Select style={{width:this.props.width}}
                        className={this.className}
                        id={"selectTagInput"}
                        mode={"tags"}
                        onChange={(tags,b)=>{
                            this.dataTableSelect.updateData((all)=>{
                                let res = [];
                                for(let i = 0 ; tags && i < tags.length; i++){
                                    let tag = tags[i];
                                    let findItem = all.find(item=>item[showField] === tag);
                                    findItem && res.push(findItem);
                                }
                                this.updateChecked(itemField,res);
                                return res;
                            });
                        }}
                        onDropdownVisibleChange={()=>this.dataTableSelect.show(checkedData)}
                        open={false}
                        placeholder={this.props.placeholder?this.props.placeholder:"请选择"}
                        value={value} />
                <Icon type={"right"} onClick={()=>this.dataTableSelect.show(checkedData)} style={{position:"absolute", top:3, right: 5, color:"#aaa7a7"}} />
                <style>{`
                    .${this.className} .ant-select-selection{
                        background: rgba(0, 80, 179, 0.04);
                        border: 1px solid rgba(0, 80, 179, 0.08)
                    }
                    .${this.className} .ant-select-selection__rendered{
                        margin-right: ${marginRight}px !important;
                    }
                `}</style>
                <DataTableSelect buildDataKeyExpression={dataTableSelect?.buildDataKeyExpression} dataRequest={dataTableSelect?.dataRequest} checkedData={checkedData} ref={dataTableSelect=>this.dataTableSelect = dataTableSelect} onOk={checkedData=>this.updateChecked(itemField,checkedData)}  />
            </Form.Item>
        );
    }

    checkData = (formData) => {
        let {field, label} = this.props;
        if(!formData[field] || formData[field].length === 0){
            message.destroy();
            message.warning("请输入" + label + "！");
            return false;
        }
        return true;
    };

    updateChecked = (itemField, checkedData) => {
        console.log("itemField, checkedData",itemField, checkedData);
        let list = this.convertCheckedData(checkedData, itemField);
        this.props.callBack && this.props.callBack(list);
    };

    convertCheckedData(checkedData, itemField) {
        let list = [];
        if (checkedData) {
            list = checkedData.map(data => {
                let res = {};
                res[itemField] = data;
                return res;
            });
        }
        return list;
    }
}

/**
 * 数据列表选择
 */
export class DataTableSelect extends BaseComponent{

    static defaultProps = {
        title: "选择约稿对象",
        width: 800,
        searchPlaceholder: "请输入账号或姓名",
        columns:[{
            "title": "用户账号",
            "dataIndex": "account",
            "key": "account",
            "width": "170px"
        },{
            "title": "用户姓名",
            "dataIndex": "name",
            "key": "name",
            "ellipsis": true,
            "width": 200,
            render: (text, record) => {
                return( <div style={{width:190,overflow: "hidden",textOverflow: "ellipsis",whiteSpace:"nowrap"}}>{text}</div>)

            }
        },{
            "title": "部门",
            "dataIndex": "deptList",
            "key": "deptList",
            "render": {
                renderComponent: "arrayGroup",
                exp: "item.name",
                join: "、"
            }
        }],
        dataRequest:{
            url: "/cm-sites-sys/user/conditionQuery",
            method: "post",
            search: "accountOrName",
            params: {
                roleOption: ["business:appointment:get"]
            }
        },
        checkedData:[],
        checkType: "checkbox",
        onOk:()=>{},
        buildDataKeyExpression :"data.key = data.id"  // data.key = data?._id + data?.deptList?.0._id;data.id=data.key;data.showName=data.name+':'+data?.deptList?.0.name
    };

    parseColumns = (columns)=>{
        columns && columns.map(column=>{
            if(column.render && column.render.renderComponent){
                try {
                    let RenderComponent = require(`../columnRender/${column.render.renderComponent}`).default;
                    let {exp, join, width} = column.render;
                    column.render = (text, record)=>{
                        return <RenderComponent width={width} record={record} text={text} exp={exp} join={join} />
                    };
                }catch (e) {
                    console.error(e)
                }
            }
        })
    };

    constructor(props) {
        super(props);
        this.parseColumns(props.columns);
        this.state = {
            visible: false,
            total: 0,
            start: 1,
            size: 10,
            dataSource:[],
            checkedData: props.checkedData
        };
        //list, exp, join
        this.getData();
    }

    componentWillUnmount() {
        this.setState = (state, callback) => {
            return;
        }
    }

    getData(start=1, size=10, search=""){
        if(this.props.dataRequest && this.props.dataRequest.url){
            let body = {start, size};
            if(search){
                body[this.props.dataRequest.search] = search;
            }
            if(this.props.dataRequest.params){
                body = {...body, ...this.props.dataRequest.params}
            }
            this.request({
                url : this.props.dataRequest.url,
                method: this.props.dataRequest.method,
                body,
                contentType:"json",
                callBack: (res)=>{
                    if (res) {
                        let tempData = [];
                        res.data && res.data.map((item, index) => {
                            let data = item;
                            eval(this.props.buildDataKeyExpression);
                            item.dataIndex = index + 1 + (start - 1) * size
                            if(this.props.dataRequest.callback) {
                                this.props.dataRequest.callback(item)
                            }
                            tempData.push({
                                ...item,
                                currentDept: item.deptList && item.deptList.length ? { ... item.deptList[0], id:  item.deptList[0]._id} : {},
                            })
                        });
                        this.setState({
                            dataSource: tempData,
                            total: res.count
                        })
                    }
                }
            })
        }
    }

    id = "a"+uuid();
    show(checkedData=[]){
        this.id = "a"+uuid();
        this.setState({visible: true, checkedData, start:1, size: 10}, ()=>this.getData(this.state.start, this.state.size));
    }

    hide(){
        this.setState({visible: false})
    }

    //分页栏
    renderPage=()=>{
        let {start, size, total}=this.state;
        if(!total) return <div style={{height:81}}/>;
        return(
            <div style={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
                borderTop: '1px solid #eee',
                paddingTop: '24px',}}
            >
                <Pagination
                    size="middle"
                    total={total}
                    showTotal={(total) => `共${total}条`}
                    showSizeChanger
                    showQuickJumper
                    current={start}
                    pageSize={size}
                    onChange={(e)=>{
                        this.state.start = e;
                        this.getData(this.state.start, this.state.size);
                    }} //页码改变时回调
                    onShowSizeChange={(start,size)=>{
                        this.state.start = 1;
                        this.state.size = size;
                        this.getData(this.state.start, this.state.size);
                    }} //每页条数改变回调
                />
            </div>
        )
    };

    rowSelection = {
        type: this.props.checkType,
        onSelectAll: (selected, selectedRows, changeRows)=>{
            let {checkedData} = this.state;
            let newCheckedData = [...checkedData];
            if(selected){ // 全选中
                for(let i = 0 ; selectedRows && i < selectedRows.length; i++){
                    let row = selectedRows[i];
                    let isAdd = true;
                    for(let j = 0 ; checkedData && j < checkedData.length; j++){
                        let data = checkedData[j];
                        if(row.id === data.id){
                            isAdd = false
                        }
                    }
                    if(isAdd){
                        newCheckedData.push(row);
                    }
                }
            }else{ // 全部不选中
                newCheckedData = [];
                for(let j = 0 ; checkedData && j < checkedData.length; j++){
                    let data = checkedData[j];
                    let isRemove = false;
                    for(let i = 0 ; changeRows && i < changeRows.length; i++){
                        let row = changeRows[i];
                        if(row.id === data.id){
                            isRemove = true;
                        }
                    }
                    if(!isRemove){
                        newCheckedData.push(data);
                    }
                }
            }
            this.setState({checkedData:newCheckedData});
        },
        onSelect: (record, selected) => {
            let {checkedData} = this.state;
            let newCheckedData = [...checkedData];
            if(selected){
                if(this.props.checkType === "radio"){
                    newCheckedData = [record];
                }else {
                    newCheckedData.push(record);
                }
            }else{
                newCheckedData = newCheckedData.filter(item=>item.id !== record.id);
            }
            this.setState({checkedData:newCheckedData});
        }
    };

    search=(value)=>{
        this.state.start = 1;
        this.state.size = 10;
        this.getData(this.state.start, this.state.size, value);
    };

    updateData = (fun)=>{
        let newData = fun(this.state.checkedData);
        this.setState({checkedData: newData});
    };

    render() {
        let newColumns = this.props.columns;
        let dataSource = this.state.dataSource;
        this.rowSelection.selectedRowKeys = this.state.checkedData.map(item=>item.key);
        return <Modal
            key={this.id}
            title={this.props.title}
            width={this.props.width}
            visible={this.state.visible}
            onOk={()=>{
                this.props.onOk(this.state.checkedData);
                this.hide();
            }}
            onCancel={()=>this.hide()}
        >
            <Scrollbars autoHide autoHeight autoHeightMax={window.innerHeight - HEADER_HEIGHT - 350}>
                <Search onSearch={value=>this.search(value)} allowClear placeholder={this.props.searchPlaceholder} style={{ width: 200, marginBottom:25 }} />
                <BaseTable rowSelection={this.rowSelection} columns={newColumns} dataSource={dataSource}/>
            </Scrollbars>
            {this.renderPage()}
        </Modal>
    }
}

export default SelectTagInput;
